import { apiRequest } from './apiClient';
import { OrderStatus, WorkStatus } from '../types/order';
import { ProofNoteInput, ProofRevisionInput } from '../screen/MyPage/proof';

export interface ProofFileInfo {
  file_url: string;
  file_type: string;
  version: number;
}

// kind: MESSAGE(쪽지·답변) / REVISION(수정요청 양식 — 무료 횟수 차감)
export interface ProofFeedbackRecord {
  sender: 'CUSTOMER' | 'ADMIN';
  kind: 'MESSAGE' | 'REVISION';
  message: string;
  revision_items?: string | null;
  attachment_path: string | null;
  extra_fee?: number;
  created_at: string;
}

// 고객 시안 수정요청 횟수 정보. used가 freeLimit 이상이면 다음 요청부터 extraFee가 결제금액에 추가된다
export interface ProofRevisionInfo {
  used: number;
  freeLimit: number;
  extraFee: number;
  totalExtraFee: number;
}

export interface ProofData {
  orderNo: string;
  customerName: string;
  shape: string | null;
  totalPrice: number | null;
  status: OrderStatus;
  workStatus: WorkStatus;
  workStartedAt: string | null;
  workCompletedAt: string | null;
  carrier: string | null;
  trackingNumber: string | null;
  proofFile: ProofFileInfo | null;
  feedbacks: ProofFeedbackRecord[];
  revision: ProofRevisionInfo;
}

function authHeaders(token: string): Record<string, string> {
  return { Authorization: `Bearer ${token}` };
}

export function fetchProof(orderId: string, token: string): Promise<ProofData> {
  return apiRequest<ProofData>(`/api/orders/${orderId}/proof`, { headers: authHeaders(token) });
}

// 수정요청 양식 제출 (무료 횟수 차감)
export function submitProofRevision(
  orderId: string,
  input: ProofRevisionInput,
  token: string,
): Promise<{ status: OrderStatus; extraFee: number; revisionCount: number }> {
  const formData = new FormData();
  formData.append('items', input.items.join(','));
  formData.append('message', input.message);
  if (input.attachment && input.attachment.length > 0) {
    formData.append('attachment', input.attachment[0]);
  }
  if (input.agreeExtraFee) {
    formData.append('agreeExtraFee', 'true');
  }

  return apiRequest(`/api/orders/${orderId}/proof/feedback`, {
    method: 'POST',
    headers: authHeaders(token),
    body: formData,
  });
}

// 쪽지 (수정 횟수와 무관)
export function sendProofNote(orderId: string, input: ProofNoteInput, token: string): Promise<{ kind: 'MESSAGE' }> {
  const formData = new FormData();
  formData.append('message', input.message);
  if (input.attachment && input.attachment.length > 0) {
    formData.append('attachment', input.attachment[0]);
  }

  return apiRequest(`/api/orders/${orderId}/proof/notes`, {
    method: 'POST',
    headers: authHeaders(token),
    body: formData,
  });
}

export function approveProof(orderId: string, token: string): Promise<{ status: OrderStatus }> {
  return apiRequest(`/api/orders/${orderId}/proof/approve`, {
    method: 'POST',
    headers: authHeaders(token),
  });
}
